import { defineComponent, Ref, ref, onMounted, onBeforeUnmount, computed, nextTick, watch, onUnmounted } from 'vue';
import { Constants } from '@truckdown/systems';
import context from '@truckdown/components-systems';

interface IProps {
    sections: string[];
}

interface ISection {
    name: string;
    isActive: boolean;
}

interface IData {
    contentSections: Ref<ISection[]>,
    activeSectionHeight: Ref<number>;
}

const getData = function (props: IProps) {
    return {
        contentSections: ref<ISection[]>(props.sections.map(function (s, idx) {
            return {
                name: s,
                isActive: idx == 0,
                height: 0
            } as ISection;
        })),
        activeSection: ref<string>(props.sections.length == 0 ? '' : props.sections[0]),
        activeSectionHeight: ref<number>(0)
    } as IData;
}

const getComputed = function (props: IProps, data: IData) {
    return {

    }
}

const getMethods = function (data: IData) {
    return {
        selectSection: function (section: ISection) {
            window.location.hash = section.name;
        }
    };
}

const resetSections = function (data: IData) {
    data.contentSections.value.forEach(function (s) {
        s.isActive = false;
    });
}

const updateHeight = function (data: IData) {
    const myDiv = document.querySelector('.nav-active');
    if (myDiv) {
        data.activeSectionHeight.value = myDiv.getBoundingClientRect().height;
    }
}

export default defineComponent({
    props: {
        sections: {
            type: Array as () => string[],
            default: []
        }
    },
    setup: function (props, ctx) {
        let data = getData(props);
        let computed = getComputed(props, data);
        let methods = getMethods(data);

        const processHash = async function () {
            let hash = window.location.hash;
            if (hash && hash.length > 0) {
                let section = data.contentSections.value.find(s => s.name == hash.substring(1));
                if (section) {
                    resetSections(data);
                    section.isActive = true;
                }
            }
            await nextTick();
            updateHeight(data);
        }

        const windowResize = async function () {
            await nextTick();
            updateHeight(data);
        }

        onMounted(async () => {
            await processHash();
            window.addEventListener('hashchange', processHash);
            window.addEventListener('resize', windowResize);
        });

        onUnmounted(() => {
            window.removeEventListener('hashchange', processHash);
            window.removeEventListener('resize', windowResize);
        });

        return {
            ...data,
            ...computed,
            ...methods
        };
    }
});
